import { render, staticRenderFns } from "./ResourcesListHorizontalSsr.vue?vue&type=template&id=1fde1ec6"
import script from "./ResourcesListHorizontalSsr.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResourcesListHorizontalSsr.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports